import * as z from "zod/v4";
import { ShopifyCategoryItemSchema } from "./get-shopify-categories";

const ShopifyCategorySearchResultSchema_ = z.object({
  item: ShopifyCategoryItemSchema,
  path: z.array(ShopifyCategoryItemSchema),
});

export const ShopifyCategorySearchResultSchema: z.ZodType<ShopifyCategorySearchResult> =
  ShopifyCategorySearchResultSchema_;
export interface ShopifyCategorySearchResult
  extends z.infer<typeof ShopifyCategorySearchResultSchema_> {}

export const searchShopifyCategories = {
  name: "searchShopifyCategories" as const,
  input: z.object({
    query: z.string(),
  }),
  output: z.object({
    results: z.array(ShopifyCategorySearchResultSchema),
  }),
};
